import { render } from "./FaceRecognitionSuccess.vue?vue&type=template&id=6cac0fa2&scoped=true"
import script from "./FaceRecognitionSuccess.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionSuccess.vue?vue&type=script&lang=js"

import "@/assets/css/idcheck/face/style.css?vue&type=style&index=0&id=6cac0fa2&scoped=true&lang=css&external"
import "./FaceRecognitionSuccess.vue?vue&type=style&index=1&id=6cac0fa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cac0fa2"]])

export default __exports__